import React from "react";

import { Trans } from "@lingui/react/macro";

import CheckIcon from "@mui/icons-material/Check";
import { MenuItemProps, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { DefaultBadge } from "@readai/common/components/Badge";
import { Row } from "@readai/pulse/components/Stack";

import MenuItem from "./MenuItem";

interface DropdownMenuItemProps extends MenuItemProps {
  label?: React.ReactNode;
  selected?: boolean;
  isDefault?: boolean;
  renderDefaultLabel?: () => React.ReactNode;
  startIcon?: React.ReactNode;
}

const StyledMenuItem = styled(MenuItem)({
  marginTop: "2px",
  marginBottom: "2px",
  minHeight: "auto",
});

/** @deprecated use Pulse SelectMenuItem */
const DropdownMenuItem = ({
  label,
  selected = false,
  isDefault,
  value,
  renderDefaultLabel,
  startIcon = null,
  ...props
}: DropdownMenuItemProps) => {
  return (
    <StyledMenuItem value={value} {...props}>
      <Row variant="apart" sx={{ width: "100%" }}>
        <Row variant="left" spacing={1} flexGrow={1}>
          {startIcon}
          {typeof label === "string" ? (
            <Typography
              variant="bodySecondaryReg"
              color={selected ? "text.default" : "text.weak"}
              fontStyle={value === "" ? "italic" : "none"}
            >
              {value === "" ? <Trans>None</Trans> : (label ?? value)}
            </Typography>
          ) : (
            label
          )}
          {isDefault &&
            (renderDefaultLabel ? renderDefaultLabel() : <DefaultBadge />)}
        </Row>
        {selected && (
          <CheckIcon
            sx={{
              fontSize: "18px",
              color: "icon.brand.default",
              marginLeft: 1,
            }}
          />
        )}
      </Row>
    </StyledMenuItem>
  );
};

export default DropdownMenuItem;
